import { Select } from "antd";
import { FC, useEffect, useState } from "react";

//!RTK
import { useSelector } from "react-redux";
import { useGetAllLevelsQuery } from "store/services/app/levels.services";

const { Option, OptGroup } = Select;

type Props = {
  onChange?: (a?: any, b?: any) => void;
  onClick?: () => void;
  onClear?: () => void;
  style?: React.CSSProperties;
  placeholder: string;
  className?: string;
  initValue?: string;
  levelsSelected?: string[];
  teacherGroupLevel: any;
};

const AppSelectGroupInstaProf: FC<Props> = ({
  onChange,
  onClick,
  onClear,
  style,
  placeholder,
  className,
  initValue,
  levelsSelected = [],
  teacherGroupLevel,
}) => {
  //!HOOKS
  const { data: levelsData, isLoading, isError } = useGetAllLevelsQuery();
  const { user } = useSelector((state) => state.auth);
  const [filteredLevels, setFilteredLevels] = useState<any>();

  useEffect(() => {
    if (teacherGroupLevel) {
      const filteredLevels = Object.fromEntries(
        Object.entries(levelsData?.data).filter(([key]) =>
          teacherGroupLevel.some((g: any) => g.levelGroup === key)
        )
      );
      setFilteredLevels(filteredLevels);
    }
    else {
      setFilteredLevels(levelsData?.data);
    }
  }, [levelsData, teacherGroupLevel]);

  return (
    <Select
      placeholder={placeholder}
      style={style}
      className={className}
      onChange={onChange}
      onClick={onClick}
      bordered={false}
      loading={isLoading}
    /* defaultValue={user?.levelId || initValue} */
    >
      {Object.keys(filteredLevels || {}).map((levelGroup) => (
        <OptGroup key={levelGroup} label={levelGroup}>
          {filteredLevels[levelGroup]?.map((level: any) => (
            <Option key={level._id} value={level._id}>
              {level.title}
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
};

export default AppSelectGroupInstaProf;
